import {
  CalendarIcon,
  PhoneIcon,
  PipelineIcon,
  SettingsIcon,
  ShieldIcon,
  UsersIcon,
} from '@/components/ui/icons'
import { paths } from '@/app/router/paths'
import type { TermLabel } from '@/hooks/useTerm'

export interface NavItem {
  to: string
  label: TermLabel
  Icon: typeof PipelineIcon
  /** Which badge count, if any, belongs on this item. */
  badge?: 'calls'
}

/** The workspace's primary navigation, in the order the design gives it. */
export const NAV_ITEMS: NavItem[] = [
  { to: paths.pipeline, label: 'CRM Pipeline', Icon: PipelineIcon },
  { to: paths.calls, label: 'Anrufsliste', Icon: PhoneIcon, badge: 'calls' },
  { to: paths.customers, label: { term: 'customer', form: 'plural' }, Icon: UsersIcon },
  { to: paths.scheduler, label: 'Termine', Icon: CalendarIcon },
  { to: paths.compliance, label: 'Anamnese', Icon: ShieldIcon },
  { to: paths.settings, label: 'Einstellungen', Icon: SettingsIcon },
]

export const DEMO_BADGES = { calls: 3 } as const
